import { render, staticRenderFns } from "./tastIndicators.vue?vue&type=template&id=5396c320&scoped=true&"
import script from "./tastIndicators.vue?vue&type=script&lang=js&"
export * from "./tastIndicators.vue?vue&type=script&lang=js&"
import style0 from "./tastIndicators.vue?vue&type=style&index=0&id=5396c320&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5396c320",
  null
  
)

export default component.exports